import axios from 'axios';
import { API_BASE_URL } from '@/config/app';

// Browser connectivity signals trigger a probe; only the configured API determines availability.
export function monitorApiAvailability(update: (available: boolean) => void): () => void {
  const client = axios.create({ baseURL: API_BASE_URL, timeout: 4000, withCredentials: false });
  let stopped = false;
  let probing = false;
  let controller: AbortController | null = null;
  const probe = async () => {
    if (stopped || probing) return;
    probing = true;
    controller = new AbortController();
    try {
      const response = await client.get('/public/runtime-config', { signal: controller.signal });
      const payload = response.data?.data;
      if (!stopped) update(response.status === 200 && Array.isArray(payload?.enabled_modules));
    } catch { if (!stopped) update(false); }
    finally { probing = false; }
  };
  const changed = () => { void probe(); };
  window.addEventListener('online', changed);
  window.addEventListener('offline', changed);
  const timer = window.setInterval(changed, 5000);
  changed();
  return () => {
    stopped = true;
    controller?.abort();
    window.clearInterval(timer);
    window.removeEventListener('online', changed);
    window.removeEventListener('offline', changed);
  };
}
